<template>
  <div>
    <Modal v-model="visible" title="配置考核周期" width="960" class="my-modal top" :mask-closable="false" :footer-hide="true">
      <Tabs v-model="formData.type" @on-click="getRankRules">
        <TabPane label="晋升" name="1">
          <Form v-if="showPupUp" ref="form" :model="formData" class="page-form" :label-width="90">
            <div v-for="(item, index) in list" :key="index" class="rules-wrap">
              <div class="f-b rules-title">
                <span>
                  <span>配置{{ index + 1 | transCode }}</span>
                  <span v-if="index != 0" @click="del(index)" class="btn-del">删除此配置</span>
                </span>
                <Button v-if="index == 0" class="btn-item" type="primary" @click="addConfig">新增配置</Button>
              </div>
              <div class="case-box">
                <FormItem prop="rankIds" label="适用职级" class="full rules-title"
                  :rules="$units.formRule.arrRequired('请选择')">
                  <CheckboxGroup v-model="item.rankIds">
                    <Checkbox v-for="rank in rankList" :key="rank.id" :label="rank.id">{{ rank.name }}</Checkbox>
                  </CheckboxGroup>
                </FormItem>
                <div class="rules-box top-line">
                  <FormItem prop="cycle" label="考核周期" class="full">
                    <span style="margin:0 10px 0 0;">每</span>
                    <Input v-model="item.cycle" placeholder="请输入" style="width: 100px" />
                    <span style="margin:0 0 0 10px;">个</span>
                    <Select v-model="item.dataType" transfer style="width: 200px"
                      @on-change="val => changeDateType(val, index)">
                      <Option value="1">自然季度</Option>
                      <Option value="2">自然月</Option>
                      <Option value="3">自然半年</Option>
                      <Option value="4">自然年</Option>
                    </Select>
                  </FormItem>
                  <FormItem v-if="item.dataType != 2" prop="monthRule" label="考核时间" class="full">
                    <span v-for="(month, idx) in item.monthRule" :key="idx">
                      <Input v-model="item.monthRule[idx]" placeholder="请输入" style="width: 100px" />
                      <span style="margin:0 10px;">月<span v-if="idx + 1 != item.monthRule.length">，</span></span>
                    </span>
                  </FormItem>
                  <FormItem prop="M" label="入职后" class="full">
                    <Select v-model="item.M" clearable transfer style="width: 100px">
                      <Option value="M">满</Option>
                      <Option value="D">第</Option>
                    </Select>
                    <Input v-model="item.N" placeholder="请输入" style="width: 100px" />
                    <Select v-model="item.D" clearable transfer style="width: 100px">
                      <Option value="Y">年</Option>
                      <Option value="M">月</Option>
                      <Option value="D">日</Option>
                      <Option v-if="formData.type == 2" value="C">考核周期</Option>
                    </Select>
                    <span style="margin:0 10px 0 0 ;">参与考核</span>
                  </FormItem>
                </div>
              </div>
            </div>
          </Form>
        </TabPane>
        <TabPane label="维持" name="2">
          <Form v-if="showPupUp" ref="form" :model="formData" class="page-form" :label-width="90">
            <div>
              <div v-for="(item, index) in list1" :key="index" class="rules-wrap">
                <div class="f-b rules-title">
                  <span>
                    <span>配置{{ index + 1 | transCode }}</span>
                    <span v-if="index != 0" @click="del(index)" class="btn-del">删除此配置</span>
                  </span>
                  <Button v-if="index == 0" class="btn-item" type="primary" @click="addConfig">新增配置</Button>
                </div>
                <div class="case-box">
                  <FormItem prop="caseName" label="适用职级" class="full rules-title">
                    <CheckboxGroup v-model="item.rankIds">
                      <Checkbox v-for="rank in rankList" :key="rank.id" :label="rank.id">{{ rank.name }}</Checkbox>
                    </CheckboxGroup>
                  </FormItem>
                  <div class="rules-box top-line">
                    <FormItem prop="cycle" label="考核周期" class="full">
                      <span style="margin:0 10px 0 0;">每</span>
                      <Input v-model="item.cycle" placeholder="请输入" style="width: 100px" />
                      <span style="margin:0 0 0 10px;">个</span>
                      <Select v-model="item.dataType" transfer style="width: 200px"
                        @on-change="val => changeDateType(val, index)">
                        <Option value="1">自然季度</Option>
                        <Option value="2">自然月</Option>
                        <Option value="3">自然半年</Option>
                        <Option value="4">自然年</Option>
                      </Select>
                    </FormItem>
                    <FormItem v-if="item.dataType != 2" prop="monthRule" label="考核时间" class="full">
                      <span v-for="(month, idx) in item.monthRule" :key="idx">
                        <Input v-model="item.monthRule[idx]" placeholder="请输入" style="width: 100px" />
                        <span style="margin:0 10px;">月<span v-if="idx + 1 != item.monthRule.length">，</span></span>
                      </span>
                    </FormItem>
                    <FormItem prop="M" label="入职后" class="full">
                      <Select v-model="item.M" clearable transfer style="width: 100px">
                        <Option value="M">满</Option>
                        <Option value="D">第</Option>
                      </Select>
                      <Input v-model="item.N" placeholder="请输入" style="width: 100px" />
                      <Select v-model="item.D" clearable transfer style="width: 100px">
                        <Option value="Y">年</Option>
                        <Option value="M">月</Option>
                        <Option value="D">日</Option>
                        <Option v-if="formData.type == 2" value="C">考核周期</Option>
                      </Select>
                      <span style="margin:0 10px 0 0 ;">参与考核</span>
                    </FormItem>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </TabPane>
      </Tabs>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save">确认</Button>
      </div>
    </Modal>

    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
  </div>
</template>

<script>
import confirmModal from '@/components/commons/confirmModal'
export default {
  components: { confirmModal },
  props: [],
  filters: {
    transCode(val) {
      let num = ''
      switch (val) {
        case 1:
          num = '一'
          break;
        case 2:
          num = '二'
          break;
        case 3:
          num = '三'
          break;
        case 4:
          num = '四'
          break;
        case 5:
          num = '五'
          break;
        case 6:
          num = '六'
          break;
      }
      return num;
    }
  },
  data() {
    return {
      visible: false,
      showPupUp: false,
      rankList: [],
      type: '1',//1-晋升 2-维持
      commissionSelected: [],
      formData: {
        id: '',
        rankId: '',
        type: '2',//类型 1-晋升 2-维持
      },
      list: [
        {
          cycle: '1',
          dataType: '1',
          monthRule: ['4', '7', '10', '1'],//考核时间月规则 例 1,4,7,10
          conditionRule: '',//满-M/第-D多长D-天 M-月 Y-年 C-参与考核
          M: 'M',//满-M/第-D
          N: '1',//D多长
          D: 'Y',//D-天 M-月 Y-年 C-参与考核
          rankIds: []
        }
      ],//方案
      list1: [
        {
          cycle: '1',
          dataType: '1',
          monthRule: ['4', '7', '10', '1'],//考核时间月规则 例 1,4,7,10
          conditionRule: '',//满-M/第-D多长D-天 M-月 Y-年 C-参与考核
          M: 'M',//满-M/第-D
          N: '1',//D多长
          D: 'Y',//D-天 M-月 Y-年 C-参与考核
          rankIds: []
        }
      ],//方案
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now();
        }
      }
    };
  },
  methods: {
    changeDateType(val, index) {
      let list = []
      if (this.formData.type == 1) {
        list = JSON.parse(JSON.stringify(this.list));
      } else {
        list = JSON.parse(JSON.stringify(this.list1));
      }
      if (val == 1) {
        list[index].monthRule = ['4', '7', '10', '1']
      } else if (val == 2) {
        list[index].monthRule = ['2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '1']
      } else if (val == 3) {
        list[index].monthRule = ['1', '7']
      } else {
        list[index].monthRule = ['1']
      }
      console.log(val)
      if (this.formData.type == 1) {
        this.list = list;
      } else {
        this.list1 = list;
      }
    },
    addConfig() {
      let list = []
      if (this.formData.type == 1) {
        list = JSON.parse(JSON.stringify(this.list));
      } else {
        list = JSON.parse(JSON.stringify(this.list1));
      }
      list.push({
        cycle: '1',
        rankIds: this.rankList.map(i => i.id),
        dataType: '1',
        monthRule: ['4', '7', '10', '1'],//考核时间月规则 例 1,4,7,10
        conditionRule: '',//满-M/第-D多长D-天 M-月 Y-年 C-参与考核
        M: 'M',//满-M/第-D
        N: '1',//D多长
        D: 'Y',//D-天 M-月 Y-年 C-参与考核
      })
      if (this.formData.type == 1) {
        this.list = list;
      } else {
        this.list1 = list;
      }
    },
    del(index) {
      let list = []
      if (this.formData.type == 1) {
        list = JSON.parse(JSON.stringify(this.list));
      } else {
        list = JSON.parse(JSON.stringify(this.list1));
      }
      if (list.length == 1) {
        return this.$notice.error('至少保留一个配置项');
      }
      this.$refs.confirmModal.open({
        title: "提示",
        content: "确定删除配置项？",
      }).then(() => {
        const bean = list[index];
        this.$http({
          url: '/buz/rankCheckConfig/del',
          type: 'GET',
          data: {
            id: bean.id,
          },
        }).then(res => {
          list.splice(index, 1);
          if (this.formData.type == 1) {
            this.list = list;
          } else {
            this.list1 = list;
          }
        })
      }).catch(() => {

      });

    },
    getRankRules(type) {
      return new Promise((resolve, reject) => {
        this.$http({
          url: '/buz/rankCheckConfig/read/list',
          type: 'GET',
          data: {
            type,
          },
        })
          .then((res) => {
            res.data.forEach(item => {
              item.dataType = item.cycle;
              if (item.conditionRule) {
                const arr = item.conditionRule.split('');
                console.log(arr)
                item.M = arr[0];
                item.N = arr[1];
                item.D = arr[2];
              }
              item.monthRule = item.monthRule ? item.monthRule.split(',') : [];
              if (item.monthRule.length == 1) {
                item.dataType = '4'
              } else if (item.monthRule.length == 2) {
                item.dataType = '3'

              } else if (item.monthRule.length == 4) {
                item.dataType = '1'

              } else if (item.monthRule.length == 12) {
                item.dataType = '2'
              }
            });
            resolve(res.data)
          })
          .catch((e) => {
          })
      })
    },

    //获取职级
    getBaseRank() {
      return new Promise((resolve) => {
        this.$http({
          url: '/buz/baseRank/read/all',
          type: 'POST',
          data: {
            baseId: this.formData.baseId,
          },
        })
          .then((res) => {
            this.rankList = res.data;
            resolve('')
          })
          .catch((e) => {
          })
      })
    },
    async open(data = {}) {
      data = JSON.parse(JSON.stringify(data));
      this.visible = true;
      this.showPupUp = true;
      await this.getBaseRank();
      this.list = [
        {
          cycle: '1',
          dataType: '1',
          monthRule: ['4', '7', '10', '1'],//考核时间月规则 例 1,4,7,10
          conditionRule: '',//满-M/第-D多长D-天 M-月 Y-年 C-参与考核
          M: 'M',//满-M/第-D
          N: '1',//D多长
          D: 'Y',//D-天 M-月 Y-年 C-参与考核
          rankIds: this.rankList.map(i => i.id)
        }
      ]//方案
      this.list1 = [
        {
          cycle: '1',
          dataType: '1',
          monthRule: ['4', '7', '10', '1'],//考核时间月规则 例 1,4,7,10
          conditionRule: '',//满-M/第-D多长D-天 M-月 Y-年 C-参与考核
          M: 'M',//满-M/第-D
          N: '1',//D多长
          D: 'Y',//D-天 M-月 Y-年 C-参与考核
          rankIds: this.rankList.map(i => i.id)
        }
      ]
      if (data.id) {
        this.formData.rankId = data.rankId;
        this.formData.type = '1';
        Promise.all([this.getRankRules('1'), this.getRankRules('2')]).then((result) => {
          console.log(result)
          result.forEach((item, idx) => {
            if (item.length) {
              if (idx == 0) {
                this.list = item
              } else {
                this.list1 = item
              }
            } else {

            }
          })
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    async save() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        let list = [], list1 = [], formArr = [];
        list = JSON.parse(JSON.stringify(this.list));
        list1 = JSON.parse(JSON.stringify(this.list1));
        let isEmpty = false, isEmpty1 = false;
        list.forEach(item => {
          if (item.rankIds.length == 0) {
            isEmpty = true;
          }
          formArr.push(...item.rankIds)
          item.monthRule = item.monthRule.join();
          item.conditionRule = item.M + item.N + item.D
          item.type = '1'
          item.rankId = this.formData.rankId;
        })
        if (Array.from(new Set(formArr)).length < formArr.length) {
          if (this.formData.type != 1) this.formData.type = '1';
          return this.$notice.error('同一个职级最多只有一个配置');
        }
        formArr = [];
        list1.forEach(item => {
          if (item.rankIds.length == 0) {
            isEmpty1 = true;
          }
          formArr.push(...item.rankIds)
          item.monthRule = item.monthRule.join();
          item.conditionRule = item.M + item.N + item.D
          item.type = '2'
          item.rankId = this.formData.rankId;
          delete item.D
          delete item.M
          delete item.N
        })
        if (Array.from(new Set(formArr)).length < formArr.length) {
          if (this.formData.type != 2) this.formData.type = '2';
          return this.$notice.error('同一个职级最多只有一个配置');
        }
        if (isEmpty) {
          if (this.formData.type != 1) this.formData.type = '1';
          return this.$notice.error('你还没有选择适用职级');
        }
        if (isEmpty1) {
          if (this.formData.type != 2) this.formData.type = '2';
          return this.$notice.error('你还没有选择适用职级');
        }
        Promise.all([this.editConfig(list), this.editConfig(list1)]).then((result) => {
          this.$notice.success('操作成功');
          this.visible = false;
        }).catch((error) => {
          console.log(error)
        })
      });
    },
    editConfig(params) {
      return new Promise((resolve, reject) => {
        this.$http({
          url: '/buz/rankCheckConfig/add',
          type: 'POST',
          data: params
        }).then(res => {
          resolve(res.data)
        });
      });

    }
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  .empty {
    color: #E3461F;
  }

  .flex {
    /deep/.ivu-form-item-content {
      display: flex;
      white-space: nowrap;
    }
  }

  .form {
    margin-top: 10px;
  }

  /deep/ {
    .ivu-modal-body {
      padding-top: 0;

      .ivu-form-item {
        width: 40%;
      }

      .full.ivu-form-item {
        width: 100% !important;

        .ivu-form-item-label {
          white-space: nowrap;
        }

        .ivu-form-item-content {

          .ivu-radio-group {
            width: 100%;
          }

          .ivu-radio-wrapper {
            width: 40%;
          }

          .ivu-select {
            width: 70%;
            margin: 0 10px;
          }
        }
      }
    }
  }

  .rules-wrap {
    .rules-title {
      padding-right: 10px;

      .btn-del {
        color: #236DFF;
        margin-left: 10px;
        cursor: pointer;
      }
    }

    .f-b {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .case-box {
      border-radius: 4px;
      border: 1px solid #eee;
      padding: 24px 0 0;
      margin: 10px 0;

      .right {
        text-align: right;
        padding: 0 10px 24px;

        .btn-del {
          cursor: pointer;
          color: #236DFF;
        }
      }

      .btn-item {
        text-align: right;

        .btn-del {
          cursor: pointer;
          color: #236DFF;
        }

        width: 20%;

        /deep/.ivu-form-item-content {
          text-align: right;
        }

      }

      .top-line {
        border-top: 1px solid #eee;
        padding-top: 24px;
      }
    }
  }
}
</style>
